import { render, staticRenderFns } from "./PendingCalls.vue?vue&type=template&id=97e22fe4&"
import script from "./PendingCalls.vue?vue&type=script&lang=js&"
export * from "./PendingCalls.vue?vue&type=script&lang=js&"
import style0 from "./PendingCalls.vue?vue&type=style&index=0&id=97e22fe4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports